import moment from "moment";
import { StateButton } from "../../Common/StateButton";
const ErrorComponent = ({errors=[]}) => {
    return (
      <div>
        <p className="fw-bold">Violations</p>
        {errors.map((err, index) => (
          <div key={index} className="error-message">
            {err.error}
          </div>
        ))}
      </div>
    );
  };

export const Details = ({ response = {}, onApprove,onDecline, loading = true }) => {
const flightOptions=  response?.processor && response?.processor['key'] === 'Flight' &&  response?.processor?.selected

    return (
        <div className="container cards" style={{ fontSize: "14px", borderRadius: "10px" }}>
            <h6 className="fw-bold text-muted">{response?.details}</h6>
            <h1 className="display-6 fw-bold">{response?.type}</h1>

            <div className="p-3 mt-4">
                <h1 className="h5 fw-bold">Details</h1>
                <div className="p-4 mt-2" style={{ border: "1px solid #ddd", borderRadius: "10px" }}>
                    <div className="mb-3 row" style={{ marginLeft: "-1.5rem", marginTop: '-10px' }}>
                        <div className="col-md-12" style={{ display: "flex", flexWrap: "wrap" }}>
                            <div className="mt-2 col-6 col-md-3">
                                <div className="p-3 bg-primary ms-2 h-100" style={{ borderRadius: "10px" }}>
                                    <div className="text-white">Status</div>
                                    <div className="text-white fw-bold">{(response && response?.approvalStatus) || "Pending"}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                  {response?.type === 'TRIP' && 
                    <div className="row">
                        <div className="col-md-6">
                            <div><span style={{ fontWeight: '600' }}>Trip Budget:</span> {response?.trip?.budget}</div>
                            <div><span style={{ fontWeight: '600' }}>Trip Title:</span> {response?.trip?.title}</div>
                            <div><span style={{ fontWeight: '600' }}>Start Date:</span> {moment(response?.trip?.start).format("DD/MM/YYYY")}</div>
                        </div>
                        <div className="col-md-6">
                            <div><span style={{ fontWeight: '600' }}>Employee:</span> {response?.employee?.name}</div>
                            <div><span style={{ fontWeight: '600' }}>Code:</span> {response?.employee?.code}</div>
                            <div><span style={{ fontWeight: '600' }}>End Date:</span> {moment(response?.trip?.end).format("DD/MM/YYYY")}</div>
                        </div>
                    </div>
                 }
                 {response?.type !== 'TRIP' && (
                    <div className="row">
                    <div className="col-md-6">
                        <div><span style={{ fontWeight: '600' }}>Employee:</span> {response?.employee?.name}</div>
                        <div><span style={{ fontWeight: '600' }}>Code:</span> {response?.employee?.code}</div>
                        <div><span style={{ fontWeight: '600' }}>Department:</span> {response?.employee?.department||'-'}</div>
                    </div>
                    <div className="col-md-6">
                        <div><span style={{ fontWeight: '600' }}>Grade:</span> {response?.employee?.level}</div>
                        <div><span style={{ fontWeight: '600' }}>Office:</span> {response?.employee?.office}</div>
                    </div>
                </div>
                 )}
                </div>
                {/* additional details  */}
                <div className="p-4 mt-2" style={{ border: "1px solid #ddd", borderRadius: "10px" }}>
                    {response?.additional && response?.additional?.length > 0 && (
                        <>
                            {response?.additional?.map((e, index) => (
                                <div key={index} style={{ flex: "1 1 calc(25% - 10px)", minWidth: "120px" }}>
                                    <span style={{ fontWeight: "600" }}>{e.key}:</span> {e.value}
                                </div>
                            ))}
                            {flightOptions && 
                                 <div style={{ flex: "1 1 calc(25% - 10px)", minWidth: "120px" }}>
                                    <span style={{ fontWeight: "600" }}>{'Flight'}:</span> {flightOptions.split('|')[0]} {flightOptions.split('|')[1]}
                                </div>
                            }
                        </>
                    )}
                </div>
                <div className="p-4 mt-2" style={{ border: "1px solid #ddd", borderRadius: "10px" }}>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                        {response?.values?.map((e, index) => (
                            <div key={index} style={{ flex: "1 1 calc(25% - 10px)", minWidth: "120px" }}>
                                <span style={{ fontWeight: "600" }}>{e.key}:</span> {e.value}
                            </div>
                        ))}
                    </div>
                </div>
                {response?.forms?.length > 0 && (
                    <div className="mt-3 mb-2">
                        <p className="fw-bold">Forms</p>
                        {response?.forms.map((e) => <div key={e.key}>
                            <p style={{ fontWeight: 250, color: 'grey' }}> {e.key}: <span style={{ fontWeight: 500, color: 'black' }}>{e.value}</span></p>
                        </div>
                        )}
                    </div>
                )}
                {/* Trip Itineraries */}
                {response?.type === 'TRIP' && 
                <div className="row">
                    <div className="col-md-12">
                        <div className="mt-5">
                            <h1 className="h5 fw-bold">Itineraries</h1>

                            <div className="mt-4 table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th style={{ 'height': '1rem', 'padding-right': '1rem' }} className="text-small">{"City"}</th>
                                            <th style={{ 'height': '1rem' }} className="text-small">{"Travel / Stay Option"}</th>
                                            <th style={{ 'height': '1rem' }} className="text-small">{"Dates"}</th>
                                        </tr>
                                    </thead>
                                    <tbody className="table-striped">{response?.trip?.itineraries?.map(TableRow)}</tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                } 
                {response?.violations && response?.violations?.length>0 && <ErrorComponent errors={response?.violations} />} 
                {response?.permissionStatus === "Completed" || response?.approvalStatus === "Approved" || response?.approvalStatus === "Declined" ? (
                    <></>
                ) : (
                    <div className="row" style={{ maxWidth: "800px" }}>
                        <div className="mt-3 col-md-4">
                            {loading ?
                                <div style={{
                                    height: 48,
                                    maxWidth: 350,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    background: 'green',
                                    marginTop: 20,
                                    borderRadius: 4
                                }}>
                                    <StateButton />
                                </div>
                                :
                                <button onClick={onApprove} className="btn btn-success" type="button" style={{ width: "100%", height: "50px" }}>
                                    <svg className="bi bi-check-lg me-2" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"></path>
                                    </svg>
                                    Approve
                                </button>
                            }
                        </div>
                        <div className="mt-3 col-md-4">
                            <button onClick={onDecline} className="btn btn-secondary" type="button" style={{ width: "100%", height: "50px" }}>
                                Decline
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

const TableRow = (item, index) => {
    return (
        <tr key={index} style={{ fontWeight: '400' }}>
            <th style={{ 'border': 'none', 'height': '1rem', 'padding-right': '1rem' }} className="text-small">{item.city.name}</th>
            <th style={{ 'border': 'none', 'height': '1rem' }} className="text-small">
                {
                    item.travelMethod === 'flight' ?
                        <div style={{ marginBottom: '8px' }}>
                            {
                                <>
                                    <div>
                                        {item.travelMethod}
                                    </div>
                                    <div>
                                        {item.travelTitle ? `${item.travelTitle}` : ''}
                                    </div>
                                </>
                            }
                            {
                                item.travelKey && item.travelKey.length ? <>
                                    {moment(Number(item.travelKey.split('|')[2])).format('hh:mm A')}-{moment(Number(item.travelKey.split('|')[3])).format('hh:mm A')}
                                </> : null
                            }
                            <br />
                            {
                                `INR ${item?.travelBudget}`
                            }
                            <br />
                        </div>
                        :
                        <div style={{ marginBottom: '8px' }}>
                            {("Travel")}: {item?.travelMethod}
                            {item.travelKey && (
                                <div >
                                    <p className='fw-500' style={{ fontSize: 9 }}>{("Suggestions")}: {item.travelKey}</p>
                                </div>
                            )}
                        </div>
                }
                {
                    item?.stayMethod === 'hotel' ?
                        <div style={{ marginBottom: '8px' }}>
                            <div>{("Hotel Name")} : {item?.hotelTitle}</div>
                            <div>{` INR ${item.stayBudget}`}</div>
                        </div>
                        : <div style={{ marginBottom: '8px' }}>
                            {("Stay")}  : {item.stayMethod}
                        </div>
                }
            </th>
            <th style={{ 'border': 'none', 'height': '1rem' }} className="text-small">{(item.startDate && item.endDate) ? <><div>{moment(item.startDate).format("DD MMM YYYY")} - </div><div>{moment(item.endDate).format("DD MMM YYYY")}</div></> : (item.endDate ? `${moment(item.endDate).format("DD MMM YYYY")}` : `${moment(item.startDate).format("DD MMM YYYY")}`)}</th>
        </tr>
    )
}